import React from 'react';
import styled from 'styled-components';

import PortalAvatar from '../../profile/PortalAvatar';
import {
  resolveInternalAssigneeIdentity,
  type InternalAssigneeLike,
} from '../../../lib/ticketAssigneeDisplay';

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
`;

const Name = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Fallback = styled.span`
  color: #9aa4b2;
`;

type Props = {
  source: InternalAssigneeLike | null | undefined;
  size?: number;
  fallback?: string;
};

export default function InternalAssigneeIdentity({
  source,
  size = 28,
  fallback = '\u2014',
}: Props) {
  const identity = resolveInternalAssigneeIdentity(source, fallback);

  if (!identity.isAssigned) {
    return <Fallback>{identity.name}</Fallback>;
  }

  return (
    <Wrap title={identity.name}>
      <PortalAvatar
        uid={identity.id}
        email={identity.email}
        firstName={identity.firstName}
        lastName={identity.lastName}
        name={identity.name}
        photoURL={identity.photoURL}
        size={size}
        disableNavigation
      />
      <Name>{identity.name}</Name>
    </Wrap>
  );
}
